<template>
   <div>

  <!-- Loader -->
<div v-if="isLoading" class="spinner-overlay">
  <div class="loading-box">
<div class="spinner" :style="{ '--spinner-color': bgTheme || '#c7222a' }"></div>

    <span>Loading ...</span>
  </div>
</div>





    <!-- Main Content -->
     <div v-if="isInviteEarnDetailPage" style="background-color: #f8f8f8;">
     <div style="height: 100vh; display: flex; flex-direction: column; background-color: #ffffff;">
  
       <!-- Scrollable Content -->
       <div style="flex: 1; overflow-y: auto;">
         <!-- Header Image -->
         <div style="position: relative;">
    <div
    v-if="!isLoading"
      style="
        background-color: #f9fafb;
        padding: 6px 8px;
        border-radius: 5px;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        width: 15px;
        position: absolute;
        top: 10px;
        left: 10px;
      "
    >
      <img
        style="cursor: pointer; width: 15px; height: 15px;"
        src="@/assets/back-icon1.png"
        alt="clip"
        class="clip-image"
        @click="redirectTo('offers')"
      />
    </div>
   <img
  v-if="offerData && offerData.offer && offerData.offer.image_url"
  :src="offerData.offer.image_url"
  alt="logo"
  style="width: 100%; height: 40vh;"
/>

  </div>
  
         <!-- Invitees Info -->
         <div style="padding: 15px; border-radius: 8px; padding-bottom: 0px;">
           <div style="background-color: #F1F3F6; border-radius: 16px; padding: 12px 16px ">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <p style="margin: 0; font-size: 16px; font-weight: 400; color: #525252;">Your Invitees</p>
             <div style="display: flex; justify-content: end; align-items: center; cursor: pointer;">
             <p 
  :style="{
    margin: '0',
    fontSize: '14px',
    fontWeight: '600',
    color: bgTheme ? bgTheme : '#C7222A'
  }" 
  @click="goToSeeAll"
>
  See all 
</p>

             <div
  :style="{
    width: '20px',
    height: '20px',
    backgroundColor: bgTheme ? bgTheme : '#C7222A', // Icon color
    WebkitMaskImage: 'url(' + asset('arrow-right-thin.png') + ')',
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskImage: 'url(' + asset('arrow-right-thin.png') + ')',
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    maskSize: 'contain',
    cursor: 'pointer',
  }"
></div>

             </div>
            </div>
            <div style="display: flex; ">
              <div style=" width: 50%; padding: 8px 24px; border-right: 1px solid #AFB3C0;">
               <p v-if="offerData && offerData.offer && offerData.offer.total_completed_events !== undefined"
   style="font-size: 32px; font-weight: 600; color: #2E2E2E; margin: 0;">
  {{ offerData.offer.total_completed_events }}
</p>

                <p style="margin: 0; margin-top: 10px; font-weight: 400; font-size: 14px; color: #525252;">Completed</p>
              </div>
              <div style=" width: 50%; padding: 8px 24px; border-left: 1px solid #AFB3C0;">
               <p 
  v-if="offerData && offerData.offer && offerData.offer.total_pending_events !== undefined"
  style="font-size: 32px; font-weight: 600; color: #2E2E2E; margin: 0;">
  {{ offerData.offer.total_pending_events }}
</p>

                <p style="margin: 0; margin-top: 10px; font-weight: 400; font-size: 14px; color: #525252;">Pending</p>
              </div>
            </div>
  
           </div>
           <div style="margin: 0px; margin-top: 5px; overflow: hidden; white-space: nowrap; width: 100%;">
  
  
             <!-- Annimation Text -->
             <div style="margin: 0px; margin-top: 5px; overflow: hidden; white-space: nowrap; width: 100%;">
   <div
     style="
       display: inline-flex;
       align-items: center;
       gap: 5px;
       animation: scrollText 10s linear infinite;
     "
   >
     <!-- <img src="@/assets/star-icon.png" alt="Star" style="width: 10px; height: 10px;" /> -->
     <p
       style="
         margin: 0;
         font-weight: 600;
         font-size: 14px;
         background: black;
         -webkit-background-clip: text;
         -webkit-text-fill-color: transparent;
       "
     >
     {{
      offerData && offerData.offer && offerData.offer.ads_text && offerData.offer.ads_text.trim()
        ? offerData.offer.ads_text.trim()
        : ""
    }}
     </p>
     <!-- <img src="@/assets/star-icon.png" alt="Star" style="width: 10px; height: 10px;" /> -->
   </div>
  </div>
  
  </div>
  
  
         </div>
  
         <!-- Rewards Info -->
         <div style="padding: 10px 15px 0px 15px; background-color: #ffffff"> 
          <!-- If image exists -->
  <img
  v-if="offerData && offerData.offer && offerData.offer.detail_image && offerData.offer.detail_image.detail_image"
  
    :src="offerData.offer.detail_image.detail_image"
    alt="logo"
    style="width: 100%; height: 50vh;"
  />
  
         </div>
      <div 
  v-if="offerData && offerData.offer && offerData.offer.show_offer_details" 
  style="display: flex; justify-content: start; align-items: center; cursor: pointer;"
>
  
  <p
  :style="{
    margin: '10px 0px 10px 15px !important',
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '12px',
    color: bgTheme ? bgTheme : '#c7222a',
    cursor: 'pointer'
  }"
  @click="showInviteEarnPage"
>
  Offer Details
</p>

   <div
  :style="{
    width: '20px',
    height: '20px',
    backgroundColor: bgTheme ? bgTheme : '#C7222A', // Icon color
    WebkitMaskImage: 'url(' + asset('arrow-right-thin.png') + ')',
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskImage: 'url(' + asset('arrow-right-thin.png') + ')',
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    maskSize: 'contain',
    cursor: 'pointer',
  }"
></div>
</div>

       </div>
  
       <!-- Fixed QR Block at Bottom -->
      <div style="background-color: #ffffff; border-top: 1px solid #eee; padding-bottom: 10px;">
         <p style="margin: 15px !important; text-align: center; font-size: 12px; font-weight: 400; color: #000000;">Invite your friends via</p>
         <div style="display: flex; padding: 10px; justify-content: space-evenly; align-items: center; padding-top: 0px;">
          <div @click="showQrPopup = true" style="text-align: center;">
 <div
  :style="{
    width: '40px',
    height: '40px',
    margin: 'auto',
    backgroundColor: bgTheme, // Background color
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '5px',
  }"
>
  <div
    :style="{
      width: '20px',
      height: '20px',
      backgroundColor: 'white', // Icon color
      WebkitMaskImage: 'url(' + asset('qr-img1.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('qr-img1.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
</div>

  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">QR Code</p>
</div>

          <div @click="getShareMsg(offerData.id, 'cp')" style="text-align: center;">
 <div
  :style="{
    width: '40px',
    height: '40px',
    margin: 'auto',
    backgroundColor: bgTheme, // Background color
    borderRadius: '50%',     // Make it circular
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '5px',
  }"
>
  <div
    :style="{
      width: '20px',  // Icon size
      height: '20px',
      backgroundColor: 'white', // Icon color
      WebkitMaskImage: 'url(' + asset('copy-img1.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('copy-img1.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
</div>

  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">Copy link</p>
</div>

           <div @click="showSharePopup = true" style="text-align: center;">
  <div
    :style="{
      width: '40px',
      height: '40px',
      margin: 'auto',
      backgroundColor: bgTheme, // Background color (same as share button)
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      marginBottom: '5px',
    }"
  >
    <div
      :style="{
        width: '20px',
        height: '20px',
        backgroundColor: 'white', // Icon color
        WebkitMaskImage: 'url(' + asset('share-img1.png') + ')',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: 'url(' + asset('share-img1.png') + ')',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
      }"
    ></div>
  </div>
  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">Share</p>
</div>

         </div>
       </div>
     </div>
  
     <!-- QR Code Popup -->
  <div v-if="showQrPopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;">
   <div style="background: white; border-radius: 40px 40px 0 0; width: 100%; max-width: 400px; text-align: center; position: relative; padding: 16px; padding-bottom: 5px;">
  
     <!-- Go Back Button (centered above popup) -->
<button @click="showQrPopup = false"
 :style="{
  position: 'absolute',
  top: '-55px',
  left: '50%',
  transform: 'translateX(-50%)',
  background: 'white',
  color: bgTheme,
  border: 'none',
  borderRadius: '50px',
  padding: '11px 16px',
  fontSize: '14px',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
  cursor: 'pointer',
  fontWeight: '700',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
  <!-- Chevron Left Icon -->
  <div
    :style="{
      width: '16px',
      height: '16px',
      backgroundColor: bgTheme, // dynamic button color
      WebkitMaskImage: 'url(' + asset('chevron-left-red.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-left-red.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
  Go back
</button>

  
     <div style="display: flex; justify-content: center; margin-bottom: 10px;">
      <div style="border: 1px solid #797979; width: 32px;">
         
      </div>
     </div>
  
   <div>
  <img
    v-if="offerData && offerData.offer && offerData.offer.qr_popup_logo"
    :src="offerData.offer.qr_popup_logo"
    alt="Share"
    class="logo-image"
    style="cursor: pointer; width: 144px; height: 66px;"
  />

  <img
    v-else
    src="@/assets/scanQRcode.png"
    alt="QR Code"
    class="logo-image"
    style="cursor: pointer; width: 60px; height: 30px;"
  />
</div>

  
    <p
  v-if="offerData && offerData.offer && offerData.offer.qr_popup_title"
  style="font-size: 16px; color: #2E2E2E; margin: 0; font-weight: 400;"
>
  {{ offerData.offer.qr_popup_title }}
</p>

<p
  v-else
  style="font-size: 16px; color: #2E2E2E; margin: 0; font-weight: 400;"
>
  To refer your friends and family
</p>

  
     <div style="display: flex; flex-direction: column; padding: 10px;">
       <!-- QR Code Image --> 
       <img
         :src="offerData.offer.qr_code"
         alt="QR Code"
         style="width: 220px; margin: 0px auto; border: 2px solid #797979; border-radius: 10px; height: 220px;"
       />
  
       <div
       @click="showSharePopup = true"
        :style="{
  background: bgTheme ? bgTheme : '#c7222a',
  color: 'white',
  border: 'none',
  borderRadius: '50px',
  padding: '10px 20px',
  fontSize: '14px',
  marginTop: '20px',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
        <img
               style="cursor: pointer; width: 20px; height: 20px;"
               src="@/assets/share-variant.png"
               alt="QR Code"
               class="logo-image"
             />
             <p style="margin: 0; font-size: 16px; font-weight: 600;"> Share QR Code</p>
       </div>
     </div>
   </div>
  </div>
  
  
     <!-- Share Popup -->
  <div v-if="showSharePopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;">
   <div
     style="
       position: relative;
       width: 100%;
       max-width: 400px;
       background: white;
       border-top-left-radius: 20px;
       border-top-right-radius: 20px;
       box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
       text-align: center;
       padding: 20px 0px;
     "
   >
     <!-- Go Back Button (centered above popup) -->
     <button @click="showSharePopup = false"
 :style="{
  position: 'absolute',
  top: '-55px',
  left: '50%',
  transform: 'translateX(-50%)',
  background: 'white',
  color: bgTheme,
  border: 'none',
  borderRadius: '50px',
  padding: '11px 16px',
  fontSize: '14px',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
  cursor: 'pointer',
  fontWeight: '700',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
  <!-- Chevron Left Icon -->
  <div
    :style="{
      width: '16px',
      height: '16px',
      backgroundColor: bgTheme, // dynamic button color
      WebkitMaskImage: 'url(' + asset('chevron-left-red.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-left-red.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
  Go back
</button>
  
     <p style="font-weight: bold; margin: 10px 0;">Share via</p>
  
     <!-- Share Options -->
     <div style="display: flex; justify-content: space-evenly; margin-top: 15px;">
       <!-- Facebook -->
       <div 
       @click="shareQrCode()"
style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[0].icon" alt="Facebook" style="width: 40px; height: 40px;" /> -->
           <img
               style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/whatsapp.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[0].text }}</p>
       </div>
       <!-- Twitter -->
       <div   @click="shareQrCode()"
       style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[1].icon" alt="Twitter" style="width: 40px; height: 40px;" /> -->
          <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/facebook.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[1].text }}</p>
       </div>
       <!-- Gmail -->
       <div  @click="shareQrCode()" style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[2].icon" alt="Gmail" style="width: 40px; height: 40px;" /> -->
          <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/instagram.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[2].text }}</p>
       </div>
     </div>
   </div>
  </div>
  
  
  
     <div id="copied-toast" class="font-bold pos-fixed pos-center-hor pull-down" style="width: 250px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none; bottom: 10%;">
           Referral link copied to clipboard
         </div>
   </div>
  
  <!-- Detail Screen of Invite & Earn -->
   <div v-else>
     <div style="height: 100vh; display: flex; flex-direction: column; background-color: #f8f8f8;">
     
     <!-- Scrollable Section -->
     <div style="flex: 1; overflow-y: auto;">
       <!-- Clip and Share Icons -->
       <div style="padding: 10px; display: flex; justify-content: space-between; align-items: center;">
         <div style="background-color: #f9fafb; padding: 6px 8px; border-radius: 5px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"">
           <img style="cursor: pointer; width: 15px; height: 15px;" src="@/assets/back-icon1.png" alt="clip" class="clip-image" @click="handleBack"/>
         </div>
          <div @click="showSharePopup = true" style="text-align: center;">
  <!-- <div
    :style="{
      width: '32px',
      height: '32px',
      margin: 'auto',
      backgroundColor: bgTheme, // Background color (same as share button)
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      marginBottom: '5px',
    }"
  >
    <div
      :style="{
        width: '20px',
        height: '20px',
        backgroundColor: 'white', // Icon color
        WebkitMaskImage: 'url(' + asset('share-img1.png') + ')',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: 'url(' + asset('share-img1.png') + ')',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
      }"
    ></div>
  </div> -->
 
</div>

       </div>
  
       <!-- From ABCD -->
       <div>
         <div style="display: flex; justify-content: start; align-items: center; padding: 0px 10px; gap: 5px;">
           <div style="background-color: #f2f3f6; padding: 5px; border: 2px solid #f2f3f6; border-radius: 50%;">
             <img
                :src="offerData.offer.logo_url"
               alt="logo" style="width: 22px; height: 22px;" />
           </div>
           <p
            v-html="offerData.offer.detail_title_text"
          style="font-weight: bold; margin: 0; font-size: 14px;"></p>
  
         </div>
  
         <!-- Reward Info -->
         <div>
           <div style="padding: 10px 15px;">
   <div
    class="details-content" v-html="offerData.offer.details"
   ></div>
  </div>
  
  
           <p style="font-size: 10px; text-align: left; font-weight: 400; line-height: 12px;">
            {{ offerData.description }}
           </p>
           <!-- <p style="margin: 5px; font-size: 12px; text-align: left;">Terms and Conditions for the ABCD App Referral Program:</p> -->
         </div>
       </div>
     </div>
  
      <!-- Fixed QR Block at Bottom -->
     <div style="background-color: #ffffff; border-top: 1px solid #eee; padding-bottom: 10px;">
         <p style="margin: 15px !important; text-align: center; font-size: 12px; font-weight: 600; color: #000000;">Invite your friends via</p>
         <div style="display: flex; padding: 10px; justify-content: space-evenly; align-items: center; padding-top: 0px;">
          <div @click="showQrPopup = true" style="text-align: center;">
 <div
  :style="{
    width: '40px',
    height: '40px',
    margin: 'auto',
    backgroundColor: bgTheme, // Background color
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '5px',
  }"
>
  <div
    :style="{
      width: '20px',
      height: '20px',
      backgroundColor: 'white', // Icon color
      WebkitMaskImage: 'url(' + asset('qr-img1.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('qr-img1.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
</div>

  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">QR Code</p>
</div>

          <div @click="getShareMsg(offerData.id, 'cp')" style="text-align: center;">
 <div
  :style="{
    width: '40px',
    height: '40px',
    margin: 'auto',
    backgroundColor: bgTheme, // Background color
    borderRadius: '50%',     // Make it circular
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '5px',
  }"
>
  <div
    :style="{
      width: '20px',  // Icon size
      height: '20px',
      backgroundColor: 'white', // Icon color
      WebkitMaskImage: 'url(' + asset('copy-img1.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('copy-img1.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
</div>

  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">Copy link</p>
</div>

           <div @click="showSharePopup = true" style="text-align: center;">
  <div
    :style="{
      width: '40px',
      height: '40px',
      margin: 'auto',
      backgroundColor: bgTheme, // Background color (same as share button)
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      marginBottom: '5px',
    }"
  >
    <div
      :style="{
        width: '20px',
        height: '20px',
        backgroundColor: 'white', // Icon color
        WebkitMaskImage: 'url(' + asset('share-img1.png') + ')',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: 'url(' + asset('share-img1.png') + ')',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
      }"
    ></div>
  </div>
  <p style="margin: 0px !important; font-size: 10px; font-weight: bold;">Share</p>
</div>

         </div>
       </div>
   </div>
  
    <!-- QR Code Popup -->
  <div v-if="showQrPopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;">
   <div style="background: white; border-radius: 40px 40px 0 0; width: 100%; max-width: 400px; text-align: center; position: relative; padding: 16px; padding-bottom: 5px;">
  
     <!-- Go Back Button (centered above popup) -->
<button @click="showQrPopup = false"
 :style="{
  position: 'absolute',
  top: '-55px',
  left: '50%',
  transform: 'translateX(-50%)',
  background: 'white',
  color: bgTheme,
  border: 'none',
  borderRadius: '50px',
  padding: '11px 16px',
  fontSize: '14px',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
  cursor: 'pointer',
  fontWeight: '700',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
  <!-- Chevron Left Icon -->
  <div
    :style="{
      width: '16px',
      height: '16px',
      backgroundColor: bgTheme, // dynamic button color
      WebkitMaskImage: 'url(' + asset('chevron-left-red.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-left-red.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
  Go back
</button>

  
     <div style="display: flex; justify-content: center; margin-bottom: 10px;">
      <div style="border: 1px solid #797979; width: 32px;">
         
      </div>
     </div>
  
     <div>
       <img
         style="cursor: pointer; width: 144px; height: 66px;"
         :src="offerData.offer.qr_popup_logo"
         alt="Share"
         class="logo-image"
       />
     </div>
  
     <p style="font-size: 16px; color: #666; margin: 0; font-weight: 400; color: #2E2E2E;">{{ offerData.offer.qr_popup_title }}</p>
  
     <div style="display: flex; flex-direction: column; padding: 10px;">
       <!-- QR Code Image --> 
       <img
         :src="offerData.offer.qr_code"
         alt="QR Code"
         style="width: 220px; margin: 0px auto; border: 2px solid #797979; border-radius: 10px; height: 220px;"
       />
  
       <div
       @click="showSharePopup = true"
        :style="{
  background: bgTheme ? bgTheme : '#c7222a',
  color: 'white',
  border: 'none',
  borderRadius: '50px',
  padding: '10px 20px',
  fontSize: '14px',
  marginTop: '20px',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
        <img
               style="cursor: pointer; width: 20px; height: 20px;"
               src="@/assets/share-variant.png"
               alt="QR Code"
               class="logo-image"
             />
             <p style="margin: 0; font-size: 16px; font-weight: 600;"> Share QR Code </p>
       </div>
  
       <!-- <button @click="showSharePopup = true"
       
         style="
           background: #c7222a;
           color: white;
           border: none;
           border-radius: 50px;
           padding: 10px 20px;
           font-size: 14px;
           margin-top: 20px;
           cursor: pointer;
         ">
         Share QR Code
       </button> -->
     </div>
   </div>
  </div>
  
   
  
  <!-- Share Popup -->
   <div v-if="showSharePopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;">
   <div
     style="
       position: relative;
       width: 100%;
       max-width: 400px;
       background: white;
       border-top-left-radius: 20px;
       border-top-right-radius: 20px;
       box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
       text-align: center;
       padding: 20px 0px;
     "
   >
     <!-- Go Back Button (centered above popup) -->
     <button @click="showSharePopup = false"
 :style="{
  position: 'absolute',
  top: '-55px',
  left: '50%',
  transform: 'translateX(-50%)',
  background: 'white',
  color: bgTheme,
  border: 'none',
  borderRadius: '50px',
  padding: '11px 16px',
  fontSize: '14px',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
  cursor: 'pointer',
  fontWeight: '700',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px'
}"
>
  <!-- Chevron Left Icon -->
  <div
    :style="{
      width: '16px',
      height: '16px',
      backgroundColor: bgTheme, // dynamic button color
      WebkitMaskImage: 'url(' + asset('chevron-left-red.png') + ')',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(' + asset('chevron-left-red.png') + ')',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
    }"
  ></div>
  Go back
</button>
  
     <p style="font-weight: bold; margin: 10px 0;">Share via</p>
  
     <!-- Share Options -->
     <div style="display: flex; justify-content: space-evenly; margin-top: 15px;">
       <!-- Facebook -->
       <div 
       @click="getShareMsg(offerData.id, 'wa')"
style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[0].icon" alt="Facebook" style="width: 40px; height: 40px;" /> -->
           <img
               style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/whatsapp.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[0].text }}</p>
       </div>
       <!-- Twitter -->
       <div  @click="getShareMsg(offerData.id, 'fb')"style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[1].icon" alt="Twitter" style="width: 40px; height: 40px;" /> -->
          <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/facebook.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[1].text }}</p>
       </div>
       <!-- Gmail -->
       <div @click="getShareMsg(offerData.id, 'ig')" style="cursor: pointer;">
         <!-- <img :src="offerData.share_options[2].icon" alt="Gmail" style="width: 40px; height: 40px;" /> -->
          <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;"
               src="@/assets/instagram.png"
               alt="back"
               class="logo-image"
             />
         <p style="margin: 5px 0; font-size: 12px;">{{ offerData.share_options[2].text }}</p>
       </div>
     </div>
   </div>
  </div>
  
  
     <div id="copied-toast" class="font-bold pos-fixed pos-center-hor pull-down" style="width: 100px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none; bottom: 10%;">
           Link Copied
         </div>
  
   </div>
   </div>
  </template>
  <script>
import { asset } from "@/utils/asset";
   import { globals } from "@/mixins/globals"
   import axios from "axios"
   import OverlapHeader from '@/components/overlapped-header'
   import Milestone from '@/components/milestone'
   import MilestoneDetailPopup from '@/components/milestone-detail-popup';
   import Drawer from "@/components/drawer"
  
   export default {
    name: "newInvites",
     mixins: [globals],
     components: {
       'header-o': OverlapHeader,
       'milestone': Milestone,
       'mile-stone-popper': MilestoneDetailPopup,
       Drawer
     },
     data() {
       return {
         headerData: {
           onlyHeader: true
         },
         is_checkin: false,
         is_invite_earn: false,
         is_invite_logo_visible: true,
         is_game_zone: false,
         is_challenge: false,
         offerData: {},
         offerTerms: [],
         hasReferee: false,
         windowWidth : window.screen.width,
         open: false,
         time_left: '',
         msData: null,
         miles_stoneObj:{},
         isInviteEarnDetailPage: true,
         showQrPopup: false,
         showSharePopup: false,
         isLoading: false,
        //  isButtonColour: "",
       }
     },
     computed: {

       sdkEvent() {
      return this.$store.state.sdkEvent;
    },

     isButtonColour() {
  if (this.sdkEvent && this.sdkEvent.isButtonColour) {
    return this.sdkEvent.isButtonColour;
  }
  return '#C7222A';
},

  isButtonTextColour() {
  if (this.sdkEvent && this.sdkEvent.isButtonTextColour) {
    return this.sdkEvent.isButtonTextColour;
  }
  return '#ffffff';
},


       isInviteEarn: function() {
         return this.is_invite_earn;
       },
       isCheckIn: function() {
         return this.is_checkin;
       },
       isGameZone: function() {
         return this.is_game_zone;
       },
       isChallenge: function (){
         return this.is_challenge;
       },
       time: ()=> {
         return  this.time_left
       },
     },

     

  //     mounted() {

  //   this.isButtonColour = this.sdkEvent.isButtonColour
   
  // },


     methods: {
  

   async shareQrCode() {
  try {
    const qrUrl =
      this.offerData &&
      this.offerData.offer &&
      this.offerData.offer.qr_code
        ? this.offerData.offer.qr_code
        : null;

    if (!qrUrl) {
      alert("QR code not available");
      return;
    }

    // Works on mobile with native share support
    if (navigator.canShare && navigator.canShare({ files: [] })) {
      const response = await fetch(qrUrl);
      const blob = await response.blob();
      const file = new File([blob], "qr-code.png", { type: blob.type });

      await navigator.share({
        title: "My QR Code",
        text: "Scan this to join!",
        files: [file],
      });
    } else {
      // Fallback: open WhatsApp Web with the QR link
      const message = encodeURIComponent(
        `Hey! Scan this QR code to join: ${qrUrl}`
      );
      const whatsappUrl = `https://wa.me/?text=${message}`;

      window.open(whatsappUrl, "_blank");
    }
  } catch (err) {
    console.error("Share failed:", err);
  }
},
  
      goToSeeAll() {
  
        console.log("Clicked See All Button..")
      this.$router.push({
        name: 'seeInvites',
        query: {
          data: JSON.stringify(this.offerData)
        }
      });
    },
  
    //    shareQrCode() {
    //    // Your logic to share the QR code
    //    console.log('Sharing QR Code');
    //    // this.showQrPopup = true
    //  },
     shareOnPlatform(platform) {
       console.log("Click Share BTn...")
     let url = encodeURIComponent(window.location.href);
     let text = encodeURIComponent("Check this out!");
     if (platform === 'facebook') {
       window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
     } else if (platform === 'twitter') {
       window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank');
     } else if (platform === 'gmail') {
       window.open(`mailto:?subject=Check this out&body=${url}`, '_blank');
     }
   },
  
      
  
       showInviteEarnPage(){
          this.isInviteEarnDetailPage = false
       },
       handleBack(){
  
         this.isInviteEarnDetailPage = true
       },
    getOfferDetails(id) {
  const url = this.$store.getters.flyyDomain + '/v1/offer_details/' + id;
  const headers = this.$store.getters.headers;

  axios.get(url, {
    mode: 'no-cors',
    headers: headers,
    params: { page: this.page }
  })
  .then((resp) => {
    if (resp.data.success) {
      var offer = resp.data;
      this.offerData = offer;
      this.showTime(this.offerData);

      var type = offer.offer_type_code;
      this.open = offer.show_tnc && !offer.tnc_accepted;

      if (type.includes("checkin")) {
        this.is_checkin = true;
        this.is_game_zone = false;
        this.is_invite_earn = false;
        this.is_challenge = false;
        this.$store.state.user.milestones = offer.milestones;
        offer.mile_stones = this.formatUserCheckins(offer);
        this.miles_stoneObj = offer;
      } else if (type.includes("invite") || type.includes("gamification")) {
        this.is_checkin = false;
        this.is_game_zone = false;
        this.is_invite_earn = true;
        this.is_challenge = false;
        this.$store.state.hasGamification = type.includes("gamification");
      } else if (type.includes("game")) {
        this.is_checkin = false;
        this.is_game_zone = true;
        this.is_invite_earn = false;
        this.is_challenge = false;
      } else if (type.includes("daily_offer")) {
        this.is_checkin = false;
        this.is_game_zone = false;
        this.is_invite_earn = false;
        this.is_challenge = true;
      }

      if (offer.offer_events && offer.offer_events.length > 0) {
        var has_referee = offer.offer_events.filter((oe) => oe.reward_referee === true);
        this.hasReferee = has_referee.length > 0;
      }

      this.offerTerms = this.formatOfferTerms(offer.offer_terms);
      if (type.includes("invite")) {
        this.$store.state.headTitle = "Invite & Earn";
      } else if (type.includes("checkin")) {
        this.$store.state.headTitle = "Daily Checkin";
      } else {
        this.$store.state.headTitle = this.formatOfferTitle(type);
      }
      this.$store.state.showHeader = false;
    }
  })
  .catch((err) => {
    console.log(err);
  })
  .finally(() => {
    this.isLoading = false; // Stop loader
  });
},


       toggle() {
         this.back();
       },
       getMsData(ms){
         this.msData = ms;
       },
       closeAndAccept() {
         this.open = !this.open;
       },
       acceptTnc() {
         var url = this.$store.getters.flyyDomain + '/accept_tnc/'+this.offerData.id;
         var headers = this.$store.getters.headers;
         axios.get(url, {
           mode: 'no-cors',
           headers: headers,
         }).then((resp) => {
           if(resp.data) {
             this.open = resp.data.success;
             this.closeAndAccept();
           }
         });
         },
       async showTime(data) {
         let dateStr = data.ends_at;
         let timeleft = '';
         var d = new Date();
         var d2 = new Date(dateStr);
         var milSec = d2-d;
         while(milSec>0){
           var d3 = new Date(milSec);
           let nrDays = (Math.floor(d3/1000/60/60/24));
           let nrHours = (Math.floor(d3/1000/60/60))%24;
           let nrMin = (Math.floor(d3/1000/60))%60;
           let nrSec = (Math.floor(d3/1000))%60;
           nrHours = nrHours<10?'0'+nrHours:nrHours;
           nrMin = nrMin<10?'0'+nrMin:nrMin;
           nrSec = nrSec<10?'0'+nrSec:nrSec;
           if(nrDays!==0){
             nrDays = nrDays<10?'0'+nrDays+'d:':nrDays+'d:';
           } else {
             nrDays = '';
           }
           timeleft = `${nrDays}${nrHours}h:${nrMin}m:${nrSec}s`;
           timeleft.replace("-","");
           milSec -= 1000
           this.time_left = timeleft;
           await this.sleep(1000);
         }
       },
       sleep(ms) {
         return new Promise(resolve => setTimeout(resolve, ms));
       },
  
     },

     created() {

       this.isLoading = true;
       if(!this.isEmpty(this.$route.params)) {
       this.is_invite_logo_visible = this.$store.state.user.isShareButtonAvailable


         this.getOfferDetails(this.$route.params.id);
  
       }
     }
   }
  </script>
  <style>

  p {
  margin: 0px !important;
 }

   .currency-type {
     position: absolute;
     top: 10px;
     right: 10px;
   }
   .milestone-wrapper {
     overflow-y: visible;
     white-space: nowrap;
     /* background: #ffffff; */
     left: 0;
     right: 0;
     margin: 15px 0px;
   }
   .check-mark {
     display: inline-block;
     transform: rotate(45deg);
     width: 5px;
     height: 13px;
     border-bottom: 2px solid #ffffff;
     border-right: 2px solid #ffffff;
   }
   .padding-bottom-60 {
     padding-bottom: 60px;
   }
   .invite-earn tr td {
     width: 90px;
   }
   .invite-earn tr td:first-child {
     width: 50px;
   }
   .accept-btn {
     padding: 7px 23px;
     border-radius: 7px;
     color: #FFFFFF;
     font-size: 16px;
     font-family: 'Montserrat', sans-serif;
     font-weight: bold;
     background: var(--bg-color);
   }
  
   @keyframes scrollText {
   0% {
     transform: translateX(100%);
   }
   100% {
     transform: translateX(-100%);
   }
  }
  
  
  .details-content p {
   margin: 6px 0;
   font-size: 12px;
   color: #333;
   line-height: 1.5;
   font-weight: normal; /* Default: sub p normal */
   text-align: left;
  }
  .details-content h4:first-of-type {
   text-align: left;
   margin: 0;
   font-size: 16px;
   font-weight: 200 !important;
  }
   
  .details-content h4 {
   text-align: left;
   margin: 5px;
   font-size: 16px;
   font-weight: 600;
  }
  
  .details-content p:first-of-type {
   font-weight: bold; /* Only the first <p> bold */
   text-align: left;
  }
  
  .details-content ul {
   padding-left: 3px;
   margin: 8px 0;
   list-style-type: disc;
   font-size: 12px;
   font-weight: 600;
   text-align: left;
  }
  
  .details-content ol {
   padding-left: 20px;
   margin: 8px 0;
   list-style-type: decimal;
  }




  .spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Dark overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-box {
  background: white;
  padding: 20px 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--spinner-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.loading-box span {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}


  
  </style>
  